import { render, staticRenderFns } from "./PredixResultTabs.vue?vue&type=template&id=29934a7d"
import script from "./PredixResultTabs.vue?vue&type=script&lang=js"
export * from "./PredixResultTabs.vue?vue&type=script&lang=js"
import style0 from "./PredixResultTabs.vue?vue&type=style&index=0&id=29934a7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports